module.exports = __webpack_public_path__ + "static/media/BeaconLogo.68713c39.png";